import OrConditionStrategy from "./OrConditionStrategy";
import AndConditionStrategy from "./AndConditionStrategy";
import {findIndex} from "lodash";
export interface Condition {
    controlTargetId: string;
    option: string;
    value: any;
}
export interface ValidationStrategy {
    validate(condition: Condition[], values: any): boolean;
}

//TODO надо протестить, возможно сюда придется передавать полный массив с полями Schema
export class RulesStrategy<T extends ValidationStrategy> {
    private strategy: T;
    private controls: any;
    constructor(controls: any) {
        this.controls = controls;
        this.strategy = null as any;
    }

    /**
     * Для поиска значений в обработанном массиве полей
     * @param controlId
     * @param values
     */
    static getValue = (controlId: string, values: Array<{ controlId: string; value: any }>): any => {
        const index = findIndex(values, (x: any) => x.controlid === controlId);
        const index2 = findIndex(values, (x: any) => x.controlId === controlId);

        const value = index > -1 ? values[index].value : null;
        const value2 = index2 > -1 ? values[index2].value : null;

        return value ?? value2;
    };

    /**
     * Для того чтобы определить экземпляру стратегию
     * @param strategy
     */
    setStrategy(strategy: T) {
        this.strategy = strategy;
    }

    /**
     * Валидация поля с выбранной стратегией
     * @param condition
     */
    validateField(condition: Condition[]) {
        if(!this.strategy) {
            throw new Error('Стратегия не определена');
        }

        if(this.strategy instanceof OrConditionStrategy || this.strategy instanceof AndConditionStrategy) {
            return this.strategy.validate(condition, this.controls);
        } else {
            throw new Error('Такой стратегии не существует');
        }
    }
}